import * as React from 'react';
import {ITextProps} from './ITextProps';
import {Base} from './Base';

export const Tt4a = (props: ITextProps) => {
  return <Base typoClass="typo4a" {...props} />;
};
